import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import { HelpService } from '@appStore/help/services/help.service';
import { ActionTypes } from '@appStore/help/actions';
import * as actions from '@appStore/help/actions';

@Injectable()
export class HelpEffects {
  constructor(private helpService: HelpService, private actions$: Actions) {}

  loadHelp$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.HelpLoad),
      exhaustMap(action => {
        return this.helpService.getHelp().pipe(
          map(help => new actions.HelpLoadSuccess(help)),
          catchError(error => of(new actions.HelpLoadFail(error)))
        );
      })
    );
  });
}
